document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('.Submenu__single');
  if (!links.length) return;

  const observers = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const link = document.querySelector(`.Submenu__single[href="#${entry.target.id}"]`);
      if (!link) return;
      link.classList.toggle('active', entry.isIntersecting);
    });
  }, { threshold: 0.3 });

  links.forEach(link => {
    const id = link.getAttribute('href').replace('#', '');
    const section = document.getElementById(id);
    if (section) observers.observe(section);
  });

  links.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const id = link.getAttribute('href').replace('#', '');
      const section = document.getElementById(id);
      if (section) section.scrollIntoView({ behavior: 'smooth' });
    });
  });
});